<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import InputMultiTexts from '@/components(new)/UI/Forms/InputMultiTexts/InputMultiTexts.vue'
import Contatos from '@/components(new)/UI/Forms/FormulariosProntos/Contatos/Contatos.vue'
import DadosConjuge from '@/components(new)/UI/Forms/FormulariosProntos/DadosConjuge/DadosConjuge.vue'
import UFMunicipio from '@/components(new)/UI/Forms/FormulariosProntos/UFMunicipio/UFMunicipio.vue'
import Endereco from '@/components(new)/UI/Forms/FormulariosProntos/Endereco/Endereco.vue'
import { opcoesSexo } from '@/libs/constants/proprietario'
import { desabilitarDatasFuturas } from '@/libs/utils/functions/dataFormater'

export default {
  components: {
    TitleWithRow,
    Label,
    InputSelect,
    InputMultiTexts,
    Contatos,
    DadosConjuge,
    UFMunicipio,
    Endereco
  },
  props: {
    cadastro: {
      type: Object,
      required: true
    },
    observer: {
      required: true
    },
    hasProcesso: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      nomeAba: 'Proprietário',
      opcoesSexo,
      options: {
        disabledDate: desabilitarDatasFuturas
      }
    }
  },
  computed: {
    proprietario () {
      return this.cadastro.proprietario.pessoa
    },
    pessoaFisica () {
      return this.cadastro.proprietario.pessoa.pessoaFisica
    },
    conjuge () {
      return this.cadastro.proprietario.conjuge
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Dados do proprietário" />
    <el-row>
      <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Nome completo'">
        <el-col :span="13">
          <Label label="Nome completo" :obrigatorio="true" />
          <el-input
            name="Nome completo"
            placeholder="Digite seu nome completo"
            clearable
            v-model="pessoaFisica.nome"
            :class="{'input erro' : errors.length}"
          />
          <span class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>
    <el-row>
      <validation-provider rules="required|cpf" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/CPF'">
        <el-col :span="6">
          <Label label="CPF" :obrigatorio="true" />
          <el-input
            name="CPF" v-model="pessoaFisica.cpf"
            v-mask="'###.###.###-##'"
            placeholder="000.000.000-00"
            clearable
            :class="{'input erro' : errors.length}"
            :disabled="hasProcesso"
          />
          <span class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
      <el-col :span="6" class="ml-forms">
        <Label label="RG" :obrigatorio="false" />
        <el-input
          name="RG" v-model="pessoaFisica.rg"
          maxlength="12"
          clearable
        />
      </el-col>
    </el-row>
    <el-row>
      <InputSelect
        label="Sexo" v-model="pessoaFisica.sexo"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        :opcoes="opcoesSexo"
        :widthColumn="6"
        rulesInput="required"
      />
      <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Data de nascimento'">
        <el-col :span="6" class="ml-forms">
          <Label label="Data de nascimento" :obrigatorio="true" />
          <el-date-picker
            v-model="pessoaFisica.dataNascimento"
            type="date"
            v-mask="'##/##/####'"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            :picker-options='options'
            placeholder="__/__/____"
            clearable
            style="width: 100%"
            :class="{'input erro' : errors.length}"
          />
          <span class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>
    <el-row>
      <UFMunicipio
        :nomeAba="nomeAba"
        :UF.sync="proprietario.pessoaFisica.naturalidade.codigoEstado"
        :municipioNome.sync="proprietario.pessoaFisica.naturalidade.nome"
        :municipioId.sync="proprietario.pessoaFisica.naturalidade.id"
        :ufObrigatorio="true"
        :municipioObrigatorio="true"
      />
    </el-row>
    <Contatos
      :emails.sync="proprietario.emails"
      :telefones.sync="proprietario.telefones"
      :observer="observer"
      :nomeAba="nomeAba"
    />
    <DadosConjuge
      :nomeAba="nomeAba"
      :estadoCivil.sync="pessoaFisica.estadoCivil"
      :rendaFamiliar.sync="pessoaFisica.rendaFamiliar"
      :nome.sync="conjuge.pessoaFisica.nome"
      :regimeBens.sync="conjuge.pessoaFisica.regimeBens"
      :cpf.sync="conjuge.pessoaFisica.cpf"
      :sexo.sync="conjuge.pessoaFisica.sexo"
      :municipioId.sync="conjuge.pessoaFisica.naturalidade.id"
      :municipioNome.sync="conjuge.pessoaFisica.naturalidade.nome"
      :UF.sync="conjuge.pessoaFisica.naturalidade.codigoEstado"
    />
    <Endereco :endereco="cadastro.proprietario.pessoa.enderecoCorrespondencia" :nomeAba="nomeAba" />
  </div>
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/proprietario/proprietario.vue